import { getIdToken } from '../auth/cognito.js';
import { API_BASE } from '../config.js';

async function apiFetch(path, opts = {}) {
  const token = getIdToken();
  const res = await fetch(`${API_BASE}${path}`, {
    ...opts,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...opts.headers
    }
  });
  if (!res.ok) throw Object.assign(new Error(`${res.status}`), { status: res.status });
  return res.json();
}

export const api = {
  evaluate: (specVersion, profile) =>
    apiFetch('/api/v1/evaluate', { method: 'POST', body: JSON.stringify({ specVersion, profile }) }),
  diff: (versionA, versionB, profile) =>
    apiFetch('/api/v1/diff', { method: 'POST', body: JSON.stringify({ versionA, versionB, profile }) }),
  listSpecs: () => apiFetch('/api/v1/specs'),
  uploadSpec: (label) =>
    apiFetch('/api/v1/specs', { method: 'POST', body: JSON.stringify({ label }) }),
  uploadSpecFile: async (presignedUrl, file) => {
    const res = await fetch(presignedUrl, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
      body: file
    });
    if (!res.ok) throw new Error(`Upload failed: ${res.status}`);
  },
  activateSpec: (label) =>
    apiFetch(`/api/v1/specs/${label}/activate`, { method: 'POST' }),
  listPersonas: () => apiFetch('/api/v1/personas'),
  createPersona: (p) =>
    apiFetch('/api/v1/personas', { method: 'POST', body: JSON.stringify(p) }),
  getPersona: (id) => apiFetch(`/api/v1/personas/${id}`),
  updatePersona: (id, p) =>
    apiFetch(`/api/v1/personas/${id}`, { method: 'PUT', body: JSON.stringify(p) }),
  deletePersona: (id) =>
    apiFetch(`/api/v1/personas/${id}`, { method: 'DELETE' }),
  bulkEvaluate: (specVersion, csvText) =>
    apiFetch(`/api/v1/evaluate/bulk?specVersion=${specVersion}`, {
      method: 'POST',
      headers: { 'Content-Type': 'text/csv' },
      body: csvText
    }),
  getJob: (id) => apiFetch(`/api/v1/jobs/${id}`)
};
